// custom-option.ts
import {ToastOptions} from 'ng2-toastr';

export class AppToastOptions extends ToastOptions {
  animate = 'slideDown'; // you can override any options available
  positionClass = 'toast-top-right';
  newestOnTop = false;
  showCloseButton = true;
  dismiss = 'auto';
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/classes/AppToastOptions.ts